var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentUser.is_login !== '1')?_c('div',{staticClass:"login_button",on:{"click":_vm.click}},[_vm._v(" ログイン / 会員登録 ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }